import React from "react"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from "../components/Common/PageBanner"
import Footer from "../components/App/Footer"
// import gallery1 from '../assets/images/gallery/gallery1.jpg'
// import gallery2 from '../assets/images/gallery/gallery2.jpg'
// import gallery3 from '../assets/images/gallery/gallery3.jpg'
// import gallery4 from '../assets/images/gallery/gallery4.jpg'
// import gallery5 from '../assets/images/gallery/gallery5.jpg'
// import gallery6 from '../assets/images/gallery/gallery6.jpg'
// import gallery7 from '../assets/images/gallery/gallery7.jpg'
// import gallery8 from '../assets/images/gallery/gallery8.jpg'
// import gallery9 from '../assets/images/gallery/gallery9.jpg'
import Lightbox from "react-image-lightbox"

import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Loadable from "@loadable/component"
const OwlCarousel = Loadable(() => import("react-owl-carousel3"))

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  items: 3,
  navText: [
    // "<i class='flaticon-left-1'></i>",
    // "<i class='flaticon-right-1'></i>"
  ],
}

const normalizePathSegment = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")

const query = graphql`
  {
    allStrapiLifeAtCompanies(
      filter: {}
      sort: { fields: createdAt, order: DESC }
    ) {
      nodes {
        festival
        bannerImg {
          localFile {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        Decription
      }
    }
  }
`

function LifeStSrashtasoft() {
  const [photoIndex, setPhotoIndex] = React.useState(0)
  const [isOpenImage, setIsOpenImage] = React.useState(false)

  const data = useStaticQuery(query)
  const life_at_details = data.allStrapiLifeAtCompanies.nodes
  // const data = life_at_details.map(i => i.bannerImg.localFile.childImageSharp.original.src)

  // console.log(`imgs`, imgs)

  return (
    <Layout>
      <Navbar />
      <PageBanner
        pageTitle="Life At Srashtasoft"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Life At Srashtasoft"
      />

      <div className="timeline-container">
        <div className="container">
          {life_at_details.map((item, index) => (
            <div
              className={`timeline-block ${index % 2 === 0 ? "even" : "odd"}`}
              key={index}
            >
              {/* Left side image if even, else right side */}
              {index % 2 === 0 ? (
                <>
                  <div className="timeline-side left">
                    <div className="timeline-image">
                      <img
                        src={
                          item.bannerImg?.localFile?.childImageSharp?.original
                            ?.src || "/images/default-event.jpg"
                        }
                        alt={item.festival}
                      />
                    </div>
                  </div>
                  <div className="timeline-side right">
                    <div className="timeline-content">
                      <h3>{item.festival}</h3>
                      <p>{item.Decription}</p>

                      <a
                        className="default-btn"
                        href={`/life-at-srashtasoft/${normalizePathSegment(item.festival)}/`}
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="timeline-side left">
                    <div className="timeline-content">
                      <h3>{item.festival}</h3>
                      <p>{item.Decription}</p>

                      <a
                        className="default-btn"
                        href={`/life-at-srashtasoft/${normalizePathSegment(item.festival)}/`}
                      >
                        Explore More
                      </a>
                    </div>
                  </div>
                  <div className="timeline-side right">
                    <div className="timeline-image">
                      <img
                        src={
                          item.bannerImg?.localFile?.childImageSharp?.original
                            ?.src || "/images/default-event.jpg"
                        }
                        alt={item.festival}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </Layout>
  )
}

export default LifeStSrashtasoft
